var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal tw-p-0",attrs:{"role":"dialog","id":"modal"}},[_c('portal-target',{attrs:{"name":_vm.source}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }